import { Link, NavLink, useLocation } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react'
import logout from '../../services/logout/logout';
import {useDispatch, useSelector} from 'react-redux';
import { ReactComponent as YamatLogo } from '../../assets/images/svg/logo20new.svg';
import { ReactComponent as ShirtIcon } from '../../assets/images/svg/shirt.svg';
import SocialNetworks from '../global/SocialNetworks';
import "./Header.css"

export default function Header(props) {

  const store = useSelector(state => state.reducer)
  let emptyurl_header="#"
  const location = useLocation()
  const hour = new Date().getHours()
  const [headerBorder, setHeaderBorder] = useState("")
  const [userGreeting, setUserGreeting] = useState('')
  const [menuOpen, setMenuOpen] = useState(false)
  const [likedCount, setLikedCount] = useState(0)
  const dispatch = useDispatch()

  // Get liked projects count from localStorage
  const updateLikedCount = () => {
    try {
      const likedProjects = JSON.parse(localStorage.getItem('likedProjects')) || []
      setLikedCount(likedProjects.length)
    } catch (e) {
      setLikedCount(0)
    }
  }

  const getUserGreeting = () => {
    if(hour < 12) setUserGreeting('בוקר טוב')
    else if(hour < 18) setUserGreeting('צוהריים טובים')
    else setUserGreeting('ערב טוב')
  }

  const headerBorderHandler = () => {
    if(location.pathname.includes("/account")){
      setHeaderBorder("none")
    }else{
      //setHeaderBorder(`3px solid ${props.partner.partnerConfig.leadingColor}`)
    }
  }

  // Handle body scroll based on menu state
  const handleBodyScroll = (isOpen) => {
    if (isOpen) {
      // Disable scrolling when menu is open
      document.body.style.overflow = 'hidden';
    } else {
      // Enable scrolling when menu is closed
      document.body.style.overflow = '';
    }
  };

  const toggleMenu = () => {
    const newMenuState = !menuOpen;
    setMenuOpen(newMenuState);
    handleBodyScroll(newMenuState);
  }

  const closeMenu = () => {
    setMenuOpen(false);
    handleBodyScroll(false);
  }

  useEffect(() => {
    headerBorderHandler()
    // Close menu when route changes
    closeMenu()
  }, [location.pathname])

  let finalMount = useRef(true)
  useEffect(() => {
    if(finalMount.current){
      finalMount.current = false
      getUserGreeting()
    }

    // Clean up function to ensure scrolling is enabled when component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, [])
  
  // Update liked count on mount and listen for storage changes
  useEffect(() => {
    updateLikedCount()

    // Listen for storage changes (from other tabs or same tab custom events)
    const handleStorageChange = (e) => {
      if (e.key === 'likedProjects' || e.type === 'likedProjectsUpdated') {
        updateLikedCount()
      }
    }

    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('likedProjectsUpdated', updateLikedCount)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('likedProjectsUpdated', updateLikedCount)
    }
  }, [])

  return (
    <>
      <header id="header" style={{borderBottom: headerBorder}}>
        <div className="header-container content-container">
          <strong className="client-logo">
            <Link to="/">
              <YamatLogo className="header_logo" />
            </Link>
          </strong>

          <div className="header-promo-links">
            <a href="https://www.good-deeds-day.org.il/gddtshirts" className="header-promo-link">
              <ShirtIcon className="promo-icon" />
              <span>רכשו את החולצה של יום המעשים הטובים</span>
            </a>
            <Link to="/open-form" className="header-promo-link">
              <span>השתתפות</span>
            </Link>
            <Link to="/liked-projects" className="header-promo-link">
              <span className="heart-icon-wrapper">
                <i className="fa fa-heart"></i>
                {likedCount > 0 && <span className="liked-count-badge">{likedCount}</span>}
              </span>
              <span>התנדבויות שמעניינות אותי</span>
            </Link>
          </div>

          {/* <div className={`header-collapse-backdrop ${menuOpen ? 'active' : ''}`}>
            <div className="header-collapse">
              <a
                href={emptyurl_header}
                className="menu-close-btn"
                role="button"
                aria-expanded={menuOpen}
                aria-label="סגור חלונית תתי תפריט"
                onClick={(e) => {
                  e.preventDefault()
                  closeMenu()
                }}
              ></a>

              <ul className="header-nav">
                  {store.headerMainLink &&
                    <li>
                      <NavLink
                        to={`/`}
                        className='main_page_link'
                        onClick={closeMenu}
                      >
                        ראשי
                      </NavLink>
                    </li>
                  }
                  {
                      props.partner.partnerConfig.headerMenu?.map(function(item, i){
                          return !(item.link === "dashboard" && !store.userDetails.isManager) &&
                            <li key={i}>
                              <NavLink
                                to={`/${item.link}`}
                                className=''
                                onClick={closeMenu}
                              >
                                {item.title}
                              </NavLink>
                            </li>
                      })
                  }
              </ul>
            </div>
          </div> */}

          {/* <div className="header-menu-wrapper">
            <a
              href={emptyurl_header}
              className="toggle-menu-btn"
              role="button"
              aria-expanded={menuOpen}
              aria-label="לפתיחת תפריט ראשי"
              onClick={(e) => {
                e.preventDefault()
                toggleMenu()
              }}
            >
              <span className="menu-icon"></span>
              <span className="menu-text">תפריט</span>
            </a>
          </div> */}

        </div>
          <Link to="/liked-projects" className="mobile-liked-link">
            <span className="heart-icon-wrapper">
              <i className="fa fa-heart"></i>
              {likedCount > 0 && <span className="liked-count-badge">{likedCount}</span>}
            </span>
          </Link>
          <button
            className="menu-btn pointer"
            role="button"
            tabIndex="0"
            aria-expanded={menuOpen}
            onClick={toggleMenu}
            style={{opacity: 1 }}
          >
            <span>תפריט</span>
            <em className="patty"></em>
          </button>
      </header>
      <div className={`menu-section ${menuOpen ? 'open' : ''}`} tabIndex="0">
        <a
          href="#"
          className="close"
          role="button"
          aria-expanded={menuOpen}
          tabIndex="0"
          onClick={(e) => {
            e.preventDefault();
            closeMenu();
          }}
        >
          <span>סגור</span>
        </a>
        <div className="container">
            <div className="row">
              <div className="col-md-4 col-sm-4 col-xs-12 column" style={{ height: '440px'}}>
                <h3 className="xs-hidden">
                    רוצים להשתתף?
                </h3>
                <ul id="menu-%d7%a8%d7%95%d7%a6%d7%99%d7%9d-%d7%9c%d7%94%d7%a9%d7%aa%d7%aa%d7%a3" className=""><li id="menu-item-5954" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5954"><a href="https://www.good-deeds-day.org.il/volunteer/" tabIndex="0">התנדבות אישית או עם קבוצה</a></li>
                  <li id="menu-item-461" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-461"><a href="https://www.good-deeds-day.org.il/businesses/" tabIndex="0">חברות ועסקים</a></li>
                  <li id="menu-item-4553" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-4553"><a href="https://www.good-deeds-day.org.il/project/" tabIndex="0">עמותות וארגונים</a></li>
                  <li id="menu-item-7123" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7123"><a href="https://www.good-deeds-day.org.il/local_authorities/" tabIndex="0">רשויות מקומיות</a></li>
                </ul>
              </div>

              <div className="col-md-4 col-sm-4 col-xs-12 column column-middle" style={{ height: '440px'}}>
                <h3 className="hidden-xs">
                    עוד דברים טובים
                </h3>
                <div className="languages">
                  <ul id="menu-%d7%a2%d7%95%d7%93-%d7%93%d7%91%d7%a8%d7%99%d7%9d-%d7%98%d7%95%d7%91%d7%99%d7%9d" className=""><li id="menu-item-5000" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5000"><a href="https://www.good-deeds-day.org.il/activities/" tabIndex="0">רעיונות טובים למעשים טובים</a></li>
                    <li id="menu-item-473" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-473"><a href="https://www.good-deeds-day.org.il/gallery/" tabIndex="0">גלריית המעשים הטובים</a></li>
                    <li id="menu-item-2698" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2698"><a href="https://www.good-deeds-day.org.il/yourstories/" tabIndex="0">שתפו אותנו בסיפורים טובים</a></li>
                    <li id="menu-item-10645" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-10645"><a href="https://www.good-deeds-day.org.il/gddtshirts/" tabIndex="0">הזמנת חולצות ליום מעשים טובים</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-xs-12 column" style={{height: '440px'}}>
                <h3 className="hidden-xs">הכירו אותנו </h3>
                <ul id="menu-%d7%94%d7%9b%d7%99%d7%a8%d7%95-%d7%90%d7%95%d7%aa%d7%a0%d7%95" className=""><li id="menu-item-419" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-401 current_page_item menu-item-419"><a href="https://www.good-deeds-day.org.il/" aria-current="page" tabIndex="0">עמוד הבית</a></li>
                  <li id="menu-item-471" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-471"><a href="https://www.good-deeds-day.org.il/about/" tabIndex="0">אודות</a></li>
                  <li id="menu-item-469" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-469"><a href="https://www.good-deeds-day.org.il/press/" tabIndex="0">אנחנו בתקשורת</a></li>
                  <li id="menu-item-470" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-470"><a href="https://www.good-deeds-day.org.il/contact/" tabIndex="0">צרו קשר</a></li>
                  <li id="menu-item-468" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-468"><a href="http://www.good-deeds-day.org/" tabIndex="0">Good Deeds Day</a></li>
                  <li id="menu-item-465" className="arabic menu-item menu-item-type-post_type menu-item-object-page menu-item-465"><a href="https://www.good-deeds-day.org.il/ar/about/" tabIndex="0" aria-label="אודות בערבית">يوم الأعمال الخيريه</a></li>
                  <li id="menu-item-466" className="hidden-xs menu-item menu-item-type-custom menu-item-object-custom menu-item-466"><a href="http://www.ruachtova.org.il/" tabIndex="0">רוח טובה</a></li>
                  <li id="menu-item-489" className="visible-xs menu-item menu-item-type-post_type menu-item-object-page menu-item-489"><a href="https://www.good-deeds-day.org.il/privacy/" tabIndex="0">מדיניות פרטיות</a></li>
                  <li id="menu-item-490" className="visible-xs menu-item menu-item-type-post_type menu-item-object-page menu-item-490"><a href="https://www.good-deeds-day.org.il/terms/" tabIndex="0">תנאי שימוש</a></li>
                  <li id="menu-item-7573" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-7573"><a href="https://www.good-deeds-day.org.il/faming/" tabIndex="0">FAMING#</a></li>
                  <li id="menu-item-7926" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7926"><a href="https://www.good-deeds-day.org.il/faq/" tabIndex="0">שאלות ותשובות</a></li>
                  </ul>
              </div>
            </div>

            <SocialNetworks />
          </div>

              <span className="focusLoop" tabIndex="0"></span>
      </div>
    </>
  )
}